import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAdminRole, getAdminToken } from "../lib/auth";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation();

  if (!getAdminToken() || !getAdminRole()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
